<template>
  <AppHeader :action="{text: 'Add', route: 'CreateVacation'}">Vacations</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Days</th>
            <th>Dates</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="vacation in data.vacations" :key="vacation.id">
            <td><router-link :to="{name: 'ViewCustomer', params: {id: vacation.customer_id}}"><b>{{ vacation.customer.name }} <small>(#{{ vacation.customer_id }})</small></b></router-link></td>
            <td><b>{{ diffBetweenDates(vacation.start_date, vacation.end_date) }}</b></td>
            <td>{{ toDate(vacation.start_date) }} <i class="ion-md-arrow-forward"></i> {{ toDate(vacation.end_date) }}</td>
            <td>{{ vacation.status }}</td>
          </tr>

          <tr v-if="data.vacations.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Vacations</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'Vacations',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      data: { vacations: [] },
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'vacations', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.data = resp.data;
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
